<template>
  <div>

    <div class="preferences">
       <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
      <breadcrumb :list="breadcrumbList" />
      <div class="main-container">
        <tl-header type="h1">Add New Salary Component</tl-header>
        <toast-message :message="errmsg" type="error" :isToastEnable='toast' @close ="(val) => toast = val"/>

        <!-- prefrences form  -->
        <form action class="preferences-form">


          <!-- name & abbreviation effective date && Round off Value-->
          <div class="threeColumnGrid">

            <div>
              <txt label="Name *" type="text" v-model="formData.name" name="name" :classname="errors.has('name')" v-validate="'required'"
                :errormsg="errors.first('name')" />
            </div>

            <div>
              <txt label="Abbreviation *" type="text" name="abbrevation" v-model="formData.abbreviation" :classname="errors.has('abbrevation')"
                v-validate="'required'" :errormsg="errors.first('abbrevation')" />
            </div>

            <div class="">
              <span class="input-label">Effective Date *</span>
              <date-picker class="" @datevalue="(val)=>formData.effectiveDate = val" :value="formData.effectiveDate" name="effectiveDate"
                :classname="errors.has('effectiveDate')" v-validate="'required'" :errormsg="errors.first('effectiveDate')"
              />
            </div>

            <!-- <tl-select class="" label="Round off Value *" :options="roundOffData" v-model="formData.roundOffID" @change="(val)=>formData.roundOff = val"
              name="roundOff" :classname="errors.has('roundOff')" v-validate="'required'" :errormsg="errors.first('roundOff')"></tl-select> -->
            <tl-select
              label="Round off Value *"
              labelText="name"
              :options="getRoundOffData"
              v-model="formData.RoundOff"
              @change="(val) => formData.RoundOff = val"
              name="Round Off"
              :classname="errors.has('Round Off')"
              v-validate="'required'"
              :errormsg="errors.first('Round Off')"></tl-select>

            <!-- Map to -->
            <div class="selectdiv">
              <!-- <div class="input-label">Map To</div>
              <select v-model="formData.mapTo" class="dropdown" name="ParentBU">
                <option v-for="(type, index) in mapToData" :key="index" :value="type.id">{{type.name}}</option>
              </select> -->
              <tl-select label="Map To" labelText="name"
              v-model="formData.MappingCategorySalaryComponent"
               :options="getSalaryComponentData"
                @change="(val) => formData.MappingCategorySalaryComponent = val" name="Map To"></tl-select>

            </div>
            <!-- pay type -->
            <!-- <tl-select class="custom-width" label="Pay Type" :options="payTypeData" :value="formData.payType" @change="(val)=>formData.payType = val"></tl-select> -->


           <tl-select
            label="Pay Type"
            labelText="name"
            :options="getPayTypeData"
            v-model="formData.SalaryComponentType"
            @change="(val) => formData.SalaryComponentType = val"
            name="Pay Type"/>

            <!-- tax status -->
            <div class="add-new-flex-basis">
              <div class="input-label">Tax Status </div>
              <div class="twoColumnGrid">
                <div class="radio-group">
                  <tl-radio
                    name="isTaxable"
                    label="Taxable"
                    id="Taxable"
                    :value="true"
                    v-model="formData.taxable"
                    />
                </div>
                <div class="radio-group ">
                  <tl-radio
                  name="isTaxable"
                  label="NonTaxable"
                  id="NonTaxable"
                  :value="false"
                  v-model="formData.taxable"
                  />
                </div>
              </div>
              <div class="check marginleft-30 radio-margin-top">
                <tl-checkbox class="headcheck" label="Tax is distributed across the year" :disable="formData.taxable == 'false'" v-model="formData.isTaxDistributed"
                />
              </div>
            </div>

            <!-- component type -->
            <div class="">
              <div class="input-label">Component Type *</div>
              <div class="radio-button-section">
                <tl-radio name="fixedOrVariable" label="Fixed" id="Fixed" :value="true" v-model="formData.fixed" />
                <tl-radio name="fixedOrVariable" label="Variable" id="Variable" :value="false" v-model="formData.fixed" />
              </div>
            </div>
          </div>
          <div class="threeColumnGrid">
            <tl-select
              class="custom-width"
              label="Calculation Type *"
              labelText="name"
              name="Calculation Type"
              :options="getCalculationTypeData"
              v-model="formData.CalculationType"
              @change="(val)=> formData.CalculationType = val"
              :classname="errors.has('Calculation Type')"
              v-validate="'required'"
              :errormsg="errors.first('Calculation Type')">
            </tl-select>

            <tl-select
                class="custom-width"
                label="Calculation On"
                labelText="name"
                :options="calculationOnData"
                v-model="formData.calculationOnActual"
                @change="(val)=>formData.calculationOnActual = val"
                name="Calculation On">
            </tl-select>

            <div>
              <div class="input-label">Value / Formula</div>
              <div class="selectdiv">
                <textarea class="form-control" name="calculation" v-model="formData.formula" />
              </div>
              <div class="label" v-if="formData.calculationTypeID.name == 'Formula'">
                <p class="anc-paragraph" @click="generateFormula">Generate Formula</p>
              </div>
            </div>
          </div>



          <div class="label">
            <h4 class="form-sub-header">Other Settings</h4>
          </div>



          <!-- Other Settings -->

          <div class="threeColumnGrid label">

            <div>
              <tl-checkbox class="headcheck" name="fbp" label="Is an FBP Component" v-model="formData.fbp" />
            </div>
            <div>
              <tl-checkbox class="headcheck" name="part_of_ctc" label="Part of CTC" v-model="formData.part_of_ctc" />
              <div class="display-flex marginleft-5p" v-if="formData.part_of_ctc">
                <tl-radio name="PartOfCTC" label="Fixed Gross" id="Fixedgross" :value="'Fixed_Gross'" v-model="formData.fixedOrVariable"
                />
                <tl-radio name="PartOfCTC" label="Variable Pay" id="variablepay" v-bind:value="'Variable_Pay'" v-model="formData.fixedOrVariable"
                />
                <tl-radio name="PartOfCTC" label="Statutory Component" id="statutory" v-bind:value="'Statutory_Component'" v-model="formData.fixedOrVariable"
                />
              </div>
            </div>
            <div>
              <tl-checkbox class="headcheck" name="reflect_this_in_payslip" label="Reflect this component in payslip" v-model="formData.reflect_this_in_payslip" />
            </div>
            <div>
              <tl-checkbox class="headcheck" name="active" label="Active" v-model="formData.active" />
            </div>
            <div>
              <tl-checkbox class="headcheck" name="create_dependant_component" label="Create Dependent Component" v-model="formData.create_dependant_component" />
            </div>

            <div>
              <tl-checkbox class="headcheck" name="gross_up_tax" label="Gross up tax" v-model="formData.gross_up_tax" />
            </div>
            <div>
              <tl-checkbox class="headcheck" name="ffs_component" label="Is an FFS component" v-model="formData.ffs_component" />
            </div>

            <div>
              <tl-checkbox class="headcheck" name="paid" label="Paid Component" v-model="formData.paid" />
            </div>

            <div>
              <tl-checkbox class="headcheck" name="consider_esi_deduction"  label="Consider for ESI Deduction" v-model="formData.consider_esi_deduction"
              />
            </div>


            <div>
              <tl-checkbox class="headcheck" name="not_dependant_on_attendance" label="Not dependent on Attendance" v-model="formData.not_dependant_on_attendance" />

              <div class="label marginleft-10p">
                <tl-checkbox class="headcheck " label="Payable even if absent full month" v-model="formData.payable_if_full_lop" v-bind:disable="!formData.not_dependant_on_attendance"
                />


                <div class="flex margintop-20">
                  <tl-checkbox class="headcheck add-flex-new-basis"
                  v-model="formData.payable_if_employee_have_joined_before_a_date"
                  name="payable_if_employee_have_joined_before_a_date"
                  label="Payable only if joined after"
                  v-bind:disable="!formData.not_dependant_on_attendance"
                  />
                  <tl-select class="custom-width-100 no-label"
                   :options="joinedAfterData"
                   :value="formData.cutoffDays"
                   @change="(val)=>formData.cutoffDays = val"
                    v-bind:disable="!formData.not_dependant_on_attendance"></tl-select>
                </div>

              </div>
            </div>


            <!-- Consider of ESI -->
            <div>
              <tl-checkbox class="headcheck" name="consider_esi_eligible" label="Consider for ESI Eligibility" v-model="formData.consider_esi_eligible"
              />
              <div class="margin-t-45px">

                <tl-select label="Pay Frequency" labelText="name" :options="getPayFrequencyData"
                  @change="(val) => formData.PayFrequency = val" name="Pay Frequency"></tl-select>
              </div>
            </div>
            <div class="hidden">
              <tl-checkbox class="headcheck margin-t-15px" name="isPFEligible" label="Consider for PF Eligibility" v-model="formData.isPFEligible"
              />
            </div>
            <div class="hidden">
             <tl-checkbox class="headcheck margin-t-15px" name="isPTEligible" label="Consider for PT Eligibility" v-model="formData.isPTEligible"
              />
            </div>
            <div>

              <tl-checkbox class="headcheck margin-t-15px" name="supperAnnuationPerk" label="Super Annuation Perk" v-model="formData.supperAnnuationPerk"
              />
            </div>
          </div>




          <!-- <tl-checkbox class="headcheck margin-t-15px" name="isESIEligible" label="Consider for ESI Eligibility" v-model="formData.isESIEligible"
          />
          <tl-checkbox class="headcheck margin-t-15px" name="isESIDeduction" label="Consider for ESI Deduction" v-model="formData.isESIDeduction"
          /> -->




          <!-- Consider of ESI -->


          <!-- Deductions -->
          <section class="sub-section">
            <div class="label-text label-text-header ">Deductions</div>
            <div class="twoColumnGrid margin-t-15px">
              <div class="twoColumnGrid">

                <!-- <tl-checkbox class="headcheck" name="chapterVIA" label="" value="chapter6a" v-model="formData.chapterVIA"
                />
                <tl-checkbox class="headcheck" name="section10" value="section10" label="Section 10" v-model="formData.section10" /> -->
                <tl-radio
                  name="deduction"
                  label="Chapter VI A"
                  id="deduction1"
                  value="Chapter VI A"
                  v-model="formData.deductionName"
                />
                <tl-radio
                  name="deduction"
                  label="Section 10"
                  id="deduction2"
                  value="Section 10"
                  v-model="formData.deductionName"
                />
                <tl-radio
                  name="deduction"
                  label="Section 17"
                  id="deduction3"
                  value="Section 17"
                  v-model="formData.deductionName"
                />
              </div>

            </div>
            <div class="margin-t-m">
                <tl-select
                    v-show="formData.deduction !== null"
                    label="Map To"
                    :value="formData.deductionSelect"
                    :options="deductionOptions"
                    @change="(val)=>formData.itSubsectionID = val"
                  />
              </div>
          </section>
          <!-- Deductions -->
          <!-- Other Settings -->

        </form>
        <br>
        <br>
        <!-- //advance button -->
      </div>

      <div class="btn-group">
        <!--bottom action button-->
        <bottom-action-container >
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn :text="saveBtnText" type="primary" @click="save" />
          </btn-grp>
        </bottom-action-container>
      </div>
    </div>
    <pop-up-message v-if="showSuccessMsg" :message="`Salary Component has been successfully added.`" btnText="Back" @back="backfrompopup()"
    />
    <!-- create formula modal -->
    <div class="modal custom-modal" v-if="showCreateModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Create Formula</h3>
        </div>
        <div class="modal-body">
          <div class="threeColumnGrid spacing threeColumnGrid-auto">

            <div class="form-group">
              <tl-select class="custom-width modal-custom-width-select" label="Brackets" :options="bracketsData" :value="formData.brackets"
                @change="brackets($event)"></tl-select>
            </div>

            <div class="form-group">
              <tl-select class="custom-width modal-custom-width-select" label="Abbreviation" :options="abbreviationData" :value="formData.abbreviation"
                @change="abbreviation($event)"></tl-select>
            </div>

            <div class="form-group">
              <tl-select class="custom-width modal-custom-width-select" label="Operators" :options="operatorsData" :value="formData.operators"
                @change="operators($event)"></tl-select>
            </div>

          </div>

          <div class="twoColumnGrid">
            <div>
              <textarea class="form-control width-100" v-model="finalFormula"></textarea>
            </div>

            <div class="justify-content-center text-center" v-show="afterSavingExpression">
              <div v-show="isValidExpression">
                <img src="@/assets/checked.svg" class="status-image" alt="check">
                <p class="status-text margintop-20">Valid Expression</p>
              </div>
              <div v-show="!isValidExpression">
                <img src="@/assets/warning_error.svg" class="status-image" alt="warning_error">
                <p class="status-text margintop-20 color-red">Invalid Expression</p>
              </div>
            </div>
          </div>
          <div class="margintop-10">
            <p class="anc-paragraph" @click="onValidExpression()">Validate</p>
          </div>
          <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancelModal" />
              <btn :text="saveBtnText" type="primary" @click="saveExpression" :disabled="!isValidExpression" />
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import { selectMixin } from "@/mixins/selectMixin";

  export default {
    name: "PreferencesAddNewComponent",
    mixins: [selectMixin],
    props: {
      mode: {
        type: String,
        default: "add"
      },
      compData: {
        type: Object,
        default: null
      }
    },
    computed: {
      ...mapState({
        componentTypes: state =>
          state.onboard.settings.salary_component_types.data,
        salaryComponentsData: state =>
          state.onboard.settings.salary_component.entityWiseData,
        globalData: state => state.globalapi.globalData
      }),
      ...mapGetters({
        getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      }),

      getRoundOffData() {
        let roundOffarray = [];
        if (this.globalData.data.RoundOff.length) {
          this.globalData.data.RoundOff.forEach(element => {
            roundOffarray.push({
              name: element.name,
              id: element.id
            });
          });
          return roundOffarray;
        } else {
          return [
            {
              name: "No Round Off Available",
              id: null
            }
          ];
        }
      },

      setRoundOffID() {
        if (this.formData.setRoundOffID) {
          return this.setSelectedOptionsByID(
            this.getRoundOffData,
            this.formData.setRoundOffID
          );
        }
      },

      getPayFrequencyData() {
        let payFrequencyArray = [];
        if (this.globalData.data.PayFrequency.length) {
          this.globalData.data.PayFrequency.forEach(element => {
            payFrequencyArray.push({
              name: element.name,
              id: element.id
            });
          });
          return payFrequencyArray;
        } else {
          return [
            {
              name: "No Pay Frequency Available",
              id: null
            }
          ];
        }
      },

      setPayFrequencyID() {
        if (this.formData.payFrequencyID) {
          return this.setSelectedOptionsByID(
            this.getRoundOffData,
            this.formData.payFrequencyID
          );
        }
      },

      getSalaryComponentData() {
        let salaryComponentArray = [];
        if (this.globalData.data.MappingCategorySalaryComponent.length) {
          this.globalData.data.MappingCategorySalaryComponent.forEach(
            element => {
              salaryComponentArray.push({
                name: element.name,
                id: element.id
              });
            }
          );
          return salaryComponentArray;
        } else {
          return [
            {
              name: "No Salary Component Available",
              id: null
            }
          ];
        }
      },

      setSalaryComponentID() {
        if (this.formData.salaryComponentTypeID) {
          return this.setSelectedOptionsByID(
            this.getSalaryComponentData,
            this.formData.salaryComponentTypeID
          );
        }
      },

      getPayTypeData() {
        let payTypeArray = [];
        if (this.globalData.data.SalaryComponentType.length) {
          this.globalData.data.SalaryComponentType.forEach(
            element => {
              payTypeArray.push({
                name: element.name,
                id: element.id
              });
            }
          );
          return payTypeArray;
        } else {
          return [
            {
              name: "No Pay Type Available",
              id: null
            }
          ];
        }
      },

      setPayTypeID() {
        if (this.formData.payType) {
          return this.setSelectedOptionsByID(
            this.getPayTypeData,
            this.formData.payType
          );
        }
      },

      getCalculationTypeData() {
        let calculationTypeArray = [];
        if (this.globalData.data.CalculationType.length) {
          this.globalData.data.CalculationType.forEach(
            element => {
              calculationTypeArray.push({
                name: element.name,
                id: element.id
              });
            }
          );
          return calculationTypeArray;
        } else {
          return [
            {
              name: "No Calculation Type Available",
              id: null
            }
          ];
        }
      },

      setCalculationTypeID() {
        if (this.formData.calculationTypeID) {
          return this.setSelectedOptionsByID(
            this.getCalculationTypeData,
            this.formData.calculationTypeID
          );
        }
      },

      leId() {
        if (this.$route.params.entity_index) {
          return this.getLegalEntityId(this.$route.params.entity_index);
        } else {
            return this.getLegalEntityId(0);
        }

      },
      saveBtnText() {
        return !this.$route.query.id ? "Save" : "Update";
      },
      deductionOptions() {
        if (this.formData.deduction == "chapter6a") {
          return this.chapter6aOptions;
        } else if (this.formData.deduction == "section10") {
          return this.section10Options;
        } else {
          return [];
        }
      },
      mapToData() {
        // let newList = [];
        // let mapToList = {};
        // if(this.salaryComponentsData[this.leId])
        // this.salaryComponentsData[this.leId].forEach((type) => {
        //    mapToList[type.name]=type.id;
        //    newList.push(type.name)
        // });
        // return newList;
        return this.salaryComponentsData[this.leId];
      },
      abbreviationData() {
        let newAbbreviationData = ["HRA", "BASIC"];
        if (this.salaryComponentsData[this.leId])
          this.salaryComponentsData[this.leId].forEach(type => {
            newAbbreviationData.push(type.abbrevation);
          });
        return newAbbreviationData;
      }
    },
    data() {
      return {
        breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Salary Component",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarycomponent`
              }
        ],
        errmsg: "",
        toast: false,
        afterSavingExpression: false,
        isValidExpression: false,
        joinedAfterData: Array.from(Array(31), (x, index) => index + 1),
        show: false,
        arrowUp: false,
        showSuccessMsg: false,
        showCreateModal: false,
        roundOffData: [
          "Nearest to 1 Rs",
          "Nearest to 50 Paisa",
          "Nearest to 5 rs",
          "None",
          "Nearest to 10 rs",
          "Round up"
        ],
        payFrequency: ["Monthly", "Quarterly", "Weekly", "Half-yearly", "Yearly"],
        payTypeData: ["Deductions", "Earnings", "Reimbursement", "Statutory"],
        calculationTypeData: ["Formula", "Flat", "Slab"],
        calculationOnData: [
          {
            name : "Deducted",
            id: false
          },{
            name : "Actual",
            id: true
          }],
        formData: {
          calculationTypeID:"",
          roundOffID:""
        },
        finalFormula: "",
        blankFormData: {
          name: '',
          abbreviation: '',
          description: '',
          MappingCategorySalaryComponent:null,
          effectiveDate: new Date(),
          RoundOff: null,
          removedByUser: false,
          taxable: true,
          gross_up_tax: false,
          fixed: true,
          CalculationType: null,
          calculationOnActual: null,
          formula: '',
          fbp: false ,
          create_dependant_component: false,
          part_of_ctc: false,
          reflect_this_in_payslip: false,
          active: false,
          PayFrequency: null,
          SalaryComponentType:  null,
          paid: false,
          consider_esi_deduction: false,
          ffs_component: false,
          minimumThreshold: 0,
          not_dependant_on_attendance: false,
          payable_if_full_lop:false ,
          payable_if_employee_have_joined_before_a_date: false,
          cutoffDays: null,
          deductionName:null,
          supperAnnuationPerk: false,
          itSubSectionID: null
        },
        bracketsData: ["(", ")", "[", "]", "{", "}"],
        operatorsData: ["+", "-", "*", "%", "/", ")"],
        chapter6aOptions: [
          "80C : 5 Years Fixed Deposit",
          "80C : 80CCC-Premium Paid for Annuity Plan of LIC or Other Insurer",
          "80C : 80CCD1-National Pension Scheme",
          "80C : Equity Linked Savings Scheme",
          "80C : Infratstructure Bond",
          "80C : LIC Deduction Through Salary",
          "80C : Life Insurance Premium",
          "80C : Mutual Funds",
          "80C : National Savings Certificate",
          "80C : National Savings Scheme",
          "80C : Pension linked Insurance",
          "80C : Post office fixed deposit schemes",
          "80C : Previous Employer 80C",
          "80C : Principal Repayment On Home Loan",
          "80C : Provident Fund",
          "80C : Public Provident Fund",
          "80C : Senior citizen savings scheme",
          "80C : Stamp Duty on House Property",
          "80C : Sukanya Samriddhi Scheme",
          "80C : Systematic Investment Plan",
          "80C : Tution Fee",
          "80C : Unit Linked Insurance Plan",
          "80C : Voluntary Provident Fund",
          "80CCD(2) : Template Contribution to NPS by Employer 10% of Basic Salary",
          "80CCD-1B : Additional contribution to NPS",
          "80CCG : RGESS (50% of the investment)",
          "80D : Medical Insurance Dependent",
          "80D : Medical Insurance for Senior Citizen",
          "80D : Medical Insurance Premium Paid Through Salary",
          "80D : Medical Insurance Self",
          "80D : Preventive Medical Checkup",
          "80DD : Maint. & Medi treatment for Physical disability",
          "80DD : Medical Treatment Expenses",
          "80DD : Medical treatment for severe disability",
          "80DDB : Med Treatment Exp. for Spec.disease Sr Citizen",
          "80DDB : Med Treatment Expenses Spec diseases",
          "80DDB : Med.Treatment Exp. for Spec.disease very Senior Citizen",
          "80E : Interest on Education Loan",
          "80EE : Interest on Home Loan Availed in 2016",
          "80G : Donation",
          "80TTA : Interest on Savings Account",
          "80TTB : Interest on Saving Account Sr Citizen",
          "80U : Person With Normal Disability",
          "80U : Person With Severe Disability",
          "Other Income: Interest on housing loan"
        ],
        section10Options: [
          "Leave Encashment",
          "LTA",
          "HRA",
          "Gratuity",
          "Telephone reimbursement",
          "Food coupons",
          "Vehicle maintenance reimbursement",
          "Driver salary",
          "Children education allowance",
          "Hostel fee allowance",
          "Uniform allowance",
          "Relocation allowance",
          "Petrol reimbursement",
          "Internet Expenses Reimbursement",
          "Professional development",
          "Periodical journals",
          "Business Entertainment",
          "Personality development",
          "Misc. Reimbursement",
          "Helper Allowance"
        ]
      };
    },
    mounted() {
      //this.fetchComponentTypes();
    },
    activated() {
     // this.formData = this.$_.cloneDeep(this.blankFormData);

      //console.log("query id", this.$route.query.id);
     // if (this.$route.query.id)
      // this.formData = this.$_.cloneDeep(this.$route.query.id);
      if (this.$route.query.id) {
          let obj = this.salaryComponentsData[this.leId].find(item => item.id == this.$route.query.id);
          if(obj.calculation_on_actual){
            obj.calculation_on_actual =  this.calculationOnData.find(item => item.id == obj.calculation_on_actual);
          }
          this.formData = this.$_.cloneDeep(obj);
      }

    },
    methods: {
      ...mapActions({
        act_create: "onboard/settings/salary_component/create",
        act_update: "onboard/settings/salary_component/update",
        act_fetch_component_types:
          "onboard/settings/salary_component_types/fetchAll",

      }),
      refresh() {
        //this.formData = this.$_.cloneDeep(this.blankFormData);
        this.$validator.reset();
      },

      toggle() {
        event.preventDefault();
        if (this.show == false) {
          this.show = true;
          this.arrowUp = true;
        } else {
          this.show = false;
          this.arrowUp = false;
        }
      },
      goBack() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarycomponent`
        });
      },
      async performAction() {
        try {
          this.$root._data.isSaving = true;
          if (!this.$route.query.id) {
            const obj = {
                le_id: this.leId,
                name: this.formData.name,
                abbreviation: this.formData.abbreviation,
                description: this.formData.description,
                mapto:this.formData.MappingCategorySalaryComponent ? this.formData.MappingCategorySalaryComponent.id : '',
                effectiveDate: new Date(this.formData.effectiveDate),
                roundOffID: this.formData.RoundOff.id,
                removedByUser: false,
                taxable: this.formData.taxable,
                gross_up_tax: this.formData.gross_up_tax ? this.formData.gross_up_tax : false,
                fixed: this.formData.fixed,
                calculationTypeID: this.formData.CalculationType.id,
                calculation_on_actual:this.formData.calculation_on_actual == 'Actual' ? true : false,
                formula: this.formData.formula,
                fbp: this.formData.fbp ? this.formData.fbp : false ,
                create_dependant_component: this.formData.create_dependant_component ? this.formData.create_dependant_component : false,
                part_of_ctc: this.formData.part_of_ctc ? this.formData.part_of_ctc : false,
                reflect_this_in_payslip: this.formData.reflect_this_in_payslip ? this.formData.reflect_this_in_payslip : false,
                active: this.formData.active ? this.formData.active : false,
                payFrequencyID: this.formData.PayFrequency.id,
                payTypeID: this.formData.SalaryComponentType ? this.formData.SalaryComponentType.id : null,
                paid: this.formData.paid ? this.formData.paid : false,
                consider_esi_deduction: this.formData.consider_esi_deduction ? this.formData.consider_esi_deduction : false,
                ffs_component: this.formData.ffs_component ? this.formData.ffs_component : false,
                minimumThreshold: 0,
                not_dependant_on_attendance: this.formData.not_dependant_on_attendance ? this.formData.not_dependant_on_attendance : false,
                payable_if_full_lop:this.formData.payable_if_full_lop ?  this.formData.payable_if_full_lop : false ,
                payable_if_employee_have_joined_before_a_date: this.formData.payable_if_employee_have_joined_before_a_date ? this.formData.payable_if_employee_have_joined_before_a_date : false,
                cutoffDays: this.formData.cutoffDays,
                deductionName:this.formData.deductionName,
                supperAnnuationPerk: this.formData.supperAnnuationPerk,
                itSubSectionID: this.formData.itSubsectionID ? this.formData.itSubsectionID.id : null
            };
            //console.log("Obj:", obj);
            await this.act_create({ data:obj });
            this.showSuccessMsg = true;
            this.refresh();
          } else if (this.$route.query.id) {
            await this.act_update({ data:this.formData });

            this.showSuccessMsg = true;
            this.refresh();
          }
          setTimeout(() => {
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          //console.log(err);
          this.toast = true;
          this.errmsg = err;
          //console.log(err);
        }
      },
      async save() {
        this.$validator.validateAll().then(result => {
          if (result) {
            //console.log("perform signup", result);
            this.performAction();
          }
        });
      },
      async saveExpression() {
        if (this.isValidExpression) {
          this.formData.formula = this.finalFormula.replace(/'/g, "");
          this.cancelModal();
        }
      },
      cancelModal() {
        this.showCreateModal = false;
      },
      generateFormula() {
        this.showCreateModal = true;
      },
      async fetchComponentTypes() {
        try {
          await this.act_fetch_component_types;
        } catch (err) {
          //console.log(err);
        }
      },
      backfrompopup() {
        this.showSuccessMsg = false;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarycomponent`
        });
      },
      onValidExpression() {
        try {
          let stringFinalFormula = this.finalFormula.toString();
          let result = eval(stringFinalFormula);
          //console.log(result);
          this.afterSavingExpression = true;
          this.isValidExpression = true;
        } catch (error) {
          //console.log(error);
          this.afterSavingExpression = true;
          this.isValidExpression = false;
        }
      },
      brackets(event) {
        //console.log(event);
        this.finalFormula += event;
      },
      abbreviation(event) {
        let addQuotes = "'" + event + "'";
        this.finalFormula += addQuotes;
      },
      operators(event) {
        this.finalFormula += event;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .custom-width {
    width: 300px;
  }

  .custom-width-100 {
    width: 100px;
  }

  .preferences {
    width: 100%;
  }

  .label {
    width: 100%;
    margin-top: 30px;
  }

  .horiz-line {
    border-bottom: 1px solid #bababa;
    flex-grow: 1;
  }

  .preferences-label {
    font-family: Montserrat;
    font-size: 14px;
    color: #1f1f1f;
    margin-bottom: 4px;
  }

  .preferences-form .input-field {
    width: 224px;
    height: 35px;
    margin-top: 5px;
    border: 1px solid #8b9c9c;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: #ffffff;
    outline: 0;
    color: #000000;
  }

  .advance-button {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
    color: #34c0be;
  }

  .inline {
    display: flex;
    width: 100%;
    align-items: flex-end;
  }

  .inline img {
    height: 9px;
    width: 10px;
    margin: 0px 6px;
  }

  .check {
    display: flex;
    align-self: center;
  }

  .checkbox-line {
    display: flex;
    align-self: center;
  }

  .checkmark {
    border-radius: 4px;
  }

  .arrow-up img {
    transform: rotate(180deg);
  }

  .left {
    border: solid white;
    border-width: 0 2px 2px 0;
    padding: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-top: 9px;
    margin-right: 20px;
  }

  .radio-margin-top {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .custom-selectdiv-width {
    &.selectdiv {
      select {
        width: 137px;
      }
    }
  }

  .add-flex-new-basis {
    flex-basis: 340px;
  }

  .no-label {
    margin-top: -10px;
  }

  .modal-custom-width-select {
    width: 130px;
  }

  .selectdiv select {
    width: 100%;
    max-width: 300px;
    height: 35px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: black;
    border: 1px solid #a7a7a7;
    padding: 0 10px;
    /* needed */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    /* background: url("../../../../../../assets/stroke-1.png"); */
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    &:focus {
      outline: none;
      border: 2px solid #37c6c0;
    }
  }

  select .dropdown {
    border-radius: 4px;
    border: 1px solid #dadada;
    padding: 10px;
    width: 93px;
    height: 35px;
    transition: ease-in-out, width 0.35s ease-in-out;

    &:focus {
      outline: none;
      border: 2px solid #37c6c0;
    }
  }

  .display-flex {
    display: flex;
  }

  .radio-button-section {
    display: flex;
  }

  .footer-width {
    width: 90%;
  }

  .flex-container {
    display: flex;
  }

  .flex-container>div {
    margin-left: 10px;
    margin-right: 10px;
    flex-basis: 222px;
  }

  .flex-container {
    &.flex-basis-auto>div {
      flex-basis: auto;
    }
    .add-new-flex-basis {
      flex-basis: 444px;
    }
  }

  .threeColumnGrid {
    display: grid;
    grid-template-columns: 300px 300px 300px;
    grid-row-gap: 15px;
    grid-column-gap: 108px;
    &.threeColumnGrid-auto {
      grid-template-columns: auto auto auto;
      grid-column-gap: 20px;
    }
  }
</style>
